import { useLocaleData, useT } from "../../i18n/useT";
import React from "react";

const Interests = () => {
  const t = useT();
  const items = useLocaleData("sections.interests.items") || [];
  return (
    <section className="p-3 p-lg-5 d-flex flex-column" id="interests">
      <h1 className="text-uppercase mb-4">{t("sections.interests.title")}</h1>
      <ul className="list-inline ml-4 text-muted text-secondary">
        {items.map((item, idx) => (
          <li key={idx}>
            <i className="fa fa-caret-right mr-3"></i>
            {item}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Interests;
